import { render, staticRenderFns } from "./RegisterView.vue?vue&type=template&id=5700d899&scoped=true"
import script from "./RegisterView.vue?vue&type=script&lang=js"
export * from "./RegisterView.vue?vue&type=script&lang=js"
import style0 from "./RegisterView.vue?vue&type=style&index=0&id=5700d899&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5700d899",
  null
  
)

export default component.exports